import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, registerables, ChartConfiguration } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-load-watch-chart',
  templateUrl: './load-watch-chart.component.html',
  styleUrls: ['./load-watch-chart.component.css']
})

export class LoadWatchChartComponent implements OnInit {
  charts: { [key: string]: Chart } = {};

  colors = {
    red: '#e44d4d',
    green: '#4cceac',
    blue: '#4d9fe4',
    yellow: '#f5c451',
    orange: '#f5a623',
    grid: '#2a3548',
    text: '#a3a3a3'
  };

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    strIMEI: new FormControl('')
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  ngOnInit(): void {
    const id = this.route.snapshot.parent?.params['id'];

    this.searchForm.patchValue({
      strIMEI: id
    })

    this.fetchData();

  }

  ngOnDestroy(): void {
    Object.values(this.charts).forEach(chart => chart.destroy());
  }

  fetchData = async (showLoading: boolean = true) => {
    let model = this.searchForm.value;

    if (showLoading) {
      this._other.Showspinner();
    }

    try {
      let res = JSON.parse((await axios.post(`LoadWatch_Charts`, this._other.stringNumberToNumber(model))).data.toString());

      this._other.nonespinner();

      if (res.ISSessionExpired == true) {
        this._tooltip.showError('لطفا وارد سیستم شوید');
        this._other.removeLocalStorage();
        this._router.navigate(['login'], { queryParams: { error: '3' } });
        return;
      }

      if (res.iResult == 0) {
        return this._tooltip.showError(res.strError);
      }

      const chartsData = JSON.parse(res.Table[0].FinalJSON);
      this.renderCharts(chartsData);

    } catch (error) {
      this._other.nonespinner();
      console.error(error);
    }
  }

  renderCharts(data: any) {
    const labels = data.Labels;
    const dailyLabels = data.DailyLabels;
    const c = data.Charts;

    const commonOptions: any = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { labels: { color: this.colors.text, boxWidth: 10, font: { size: 10, family: 'vazir' } } },
        zoom: {
          pan: { enabled: true, mode: 'x' },
          zoom: { wheel: { enabled: true }, pinch: { enabled: true }, mode: 'x' }
        }
      },
      scales: {
        x: { grid: { color: this.colors.grid }, ticks: { color: this.colors.text, font: { size: 10, family: 'vazir' }, maxTicksLimit: 15 } },
        y: { grid: { color: this.colors.grid }, ticks: { color: this.colors.text, font: { size: 10, family: 'vazir' } } }
      }
    };

    const createLineChart = (id: string, datasets: any[], extraOpts = {}) => {
      if (this.charts[id]) this.charts[id].destroy();

      const config: ChartConfiguration = {
        type: 'line',
        data: { labels: labels, datasets: datasets },
        options: { ...commonOptions, ...extraOpts }
      };

      const ctx = document.getElementById(id) as HTMLCanvasElement;
      if (ctx) {
        this.charts[id] = new Chart(ctx, config);
      }
    };

    // 1. درصد بار
    createLineChart('chartLoad', [{
      label: 'درصد بار', data: c.LoadPercentage,
      borderColor: this.colors.green, backgroundColor: this.colors.green + '20', fill: true, tension: 0.4, borderWidth: 2, pointRadius: 2
    }]);

    // 2. توان اکتیو
    createLineChart('chartActivePower', [
      { label: 'L1', data: c.ActivePowerL1, borderColor: this.colors.red, tension: 0.4, borderWidth: 1.5, pointRadius: 2 },
      { label: 'L2', data: c.ActivePowerL2, borderColor: this.colors.green, tension: 0.4, borderWidth: 1.5, pointRadius: 2 },
      { label: 'L3', data: c.ActivePowerL3, borderColor: this.colors.blue, tension: 0.4, borderWidth: 1.5, pointRadius: 2 }
    ]);

    // 3. جریان
    createLineChart('chartCurrent', [
      { label: 'L1', data: c.CurrentL1, borderColor: this.colors.red, tension: 0.4, pointRadius: 2 },
      { label: 'L2', data: c.CurrentL2, borderColor: this.colors.green, tension: 0.4, pointRadius: 2 },
      { label: 'L3', data: c.CurrentL3, borderColor: this.colors.blue, tension: 0.4, pointRadius: 2 }
    ]);

    // 4. ولتاژ
    createLineChart('chartVoltage', [
      { label: 'L1', data: c.VoltageL1, borderColor: this.colors.red, tension: 0.4, pointRadius: 2 },
      { label: 'L2', data: c.VoltageL2, borderColor: this.colors.green, tension: 0.4, pointRadius: 2 },
      { label: 'L3', data: c.VoltageL3, borderColor: this.colors.blue, tension: 0.4, pointRadius: 2 }
    ]);

    // 5. فرکانس
    createLineChart('chartFrequency', [{
      label: 'Hz', data: c.Frequency,
      borderColor: this.colors.yellow, tension: 0.4, pointRadius: 2
    }]);

    // 6. ضریب توان
    createLineChart('chartPF', [{
      label: 'PF', data: c.PowerFactor,
      borderColor: this.colors.green, tension: 0.4, pointRadius: 2
    }]);

    // 7. انرژی تولیدی (میله‌ای)
    if (this.charts['chartEnergy']) this.charts['chartEnergy'].destroy();
    const energyCtx = document.getElementById('chartEnergy') as HTMLCanvasElement;
    if (energyCtx) {
      this.charts['chartEnergy'] = new Chart(energyCtx, {
        type: 'bar',
        data: {
          labels: dailyLabels,
          datasets: [{
            label: 'انرژی (kWh)',
            data: c.DailyEnergies,
            backgroundColor: c.DailyEnergies.map((v: number) => v > 1000 ? this.colors.blue : this.colors.green),
            borderRadius: 4
          }]
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { display: false }, zoom: commonOptions.plugins.zoom },
          scales: {
            x: { grid: { display: false }, ticks: { color: this.colors.text, font: { size: 10 } } },
            y: { grid: { color: this.colors.grid }, ticks: { color: this.colors.text } }
          }
        }
      });
    }

    // 8. عدم تعادل
    createLineChart('chartUnbalance', [
      { label: 'عدم تعادل جریان (%)', data: c.UnbalanceCurrent, borderColor: '#ffffff', borderWidth: 2, tension: 0.4, pointRadius: 2 },
      { label: 'عدم تعادل ولتاژ (%)', data: c.UnbalanceVoltage, borderColor: this.colors.yellow, borderWidth: 2, tension: 0.4, pointRadius: 2 },
      { label: 'عدم تعادل توان (%)', data: c.UnbalancePower, borderColor: this.colors.red, borderWidth: 2, tension: 0.4, pointRadius: 2 }
    ]);

    // 9. راندمان و سلامت
    createLineChart('chartHealthEff', [
      { label: 'راندمان ژنراتور (%)', data: c.GeneratorEfficiency, borderColor: this.colors.blue, borderWidth: 2, tension: 0.4, pointRadius: 2 },
      { label: 'سلامت فازها', data: c.PhaseHealthScore, borderColor: this.colors.green, borderWidth: 2, tension: 0.4, pointRadius: 2 },
      { label: 'سلامت سیستم برق', data: c.ElectricalHealthScore, borderColor: this.colors.yellow, borderWidth: 2, tension: 0.4, pointRadius: 2 }
    ]);

    // 10. دماها
    createLineChart('chartTemp', [
      { label: 'دمای مایع خنک‌کننده', data: c.CoolantTemp, borderColor: this.colors.blue, tension: 0.4, pointRadius: 2 },
      { label: 'دمای روغن', data: c.OilTemp, borderColor: this.colors.yellow, tension: 0.4, pointRadius: 2 }
    ]);
  }

}
